import { render } from "./EntitiesList.vue?vue&type=template&id=50cc000a&scoped=true&ts=true"
import script from "./EntitiesList.vue?vue&type=script&lang=ts"
export * from "./EntitiesList.vue?vue&type=script&lang=ts"

import "./EntitiesList.vue?vue&type=style&index=0&id=50cc000a&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc000a"]])

export default __exports__